export const useAnimate = (sliderValue, maxIndex) => {
  const clearId = ref(null)
  const isPlaying = ref(false)

  const anime = () => {
    if (!isPlaying.value) return
    const nextValue = sliderValue.value < maxIndex.value ? sliderValue.value + 1 : 0
    sliderValue.value = nextValue

    const delay = nextValue === 0 ? 2000 : 1000
    clearId.value = setTimeout(anime, delay)
  }

  const onClickPlay = () => {
    isPlaying.value = true
    clearTimeout(clearId.value)
    anime()
  }
  const onClickStop = () => {
    isPlaying.value = false
    clearTimeout(clearId.value)
  }

  return {
    isPlaying,
    clearId,
    onClickPlay,
    onClickStop
  }
}
